import { render, staticRenderFns } from "./TransactionForm.vue?vue&type=template&id=ff57b032&scoped=true"
import script from "./TransactionForm.vue?vue&type=script&lang=js"
export * from "./TransactionForm.vue?vue&type=script&lang=js"
import style0 from "./TransactionForm.vue?vue&type=style&index=0&id=ff57b032&prod&lang=scss&scoped=true"
import style1 from "./TransactionForm.vue?vue&type=style&index=1&id=ff57b032&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_40df3e800382af9a7a59c1fe33ba5098/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff57b032",
  null
  
)

export default component.exports